import React from 'react';

const info = {
  name: "Javier Blanco Rojo",
  company: "JBR INMOBILIARIA",
  phone: "+34 673 361 681",
  email: "javierblanco@jbrinmobiliaria.com",
  address: "Calle Goya 6, Valladolid"
};

const navLinks = [
  { name: 'Inicio', href: '#inicio' },
  { name: 'Sobre mí', href: '#sobre-mi' },
  { name: 'Servicios', href: '#servicios' },
  { name: 'Trayectoria', href: '#trayectoria' }
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#333333] py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-2">
            <a href="#inicio" onClick={(e) => scrollToSection(e, '#inicio')} className="inline-block">
              <span className="text-xl font-medium text-white tracking-tight">{info.name}</span>
            </a>
            <p className="text-sm text-white/60 mt-4 max-w-sm leading-relaxed">
              Empresario inmobiliario con más de 20 años de experiencia. Más de 5.000 transacciones realizadas y reconocido como Mejor Inmobiliaria de Castilla y León en Google durante 4 años consecutivos.
            </p>
            <p className="text-sm text-white/40 mt-6">
              Fundador de {info.company} desde 2004
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">Navegación</h4>
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  {link.name}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">Contacto</h4>
            <div className="space-y-3">
              <a href={"tel:" + info.phone} className="block text-sm text-white/60 hover:text-white transition-colors">
                {info.phone}
              </a>
              <a href={"mailto:" + info.email} className="block text-sm text-white/60 hover:text-white transition-colors">
                {info.email}
              </a>
              <p className="text-sm text-white/60">
                {info.address}
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/40">
            © {currentYear} {info.name}. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-white/40 hover:text-white/60 transition-colors">
              Política de Privacidad
            </a>
            <a href="#" className="text-xs text-white/40 hover:text-white/60 transition-colors">
              Aviso Legal
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
